@if (serviceCode() === serviceCodes.RollOff) {
  <div class="flex w-full cursor-pointer items-start gap-4 p-4 md:items-center md:px-5">
    <div
      [ngClass]="{
        'border-[--container-volume-card-selected-icon-bg-color] bg-[--container-volume-card-selected-icon-bg-color]':
          selected(),
        'border-gray-700': !selected(),
      }"
      class="flex size-6 shrink-0 items-center justify-center rounded-[50%] border"
    >
      @if (selected()) {
        <csl-icon name="checkmark" class="size-6 bg-[--container-volume-card-selected-icon-color]" />
      }
    </div>
    <div class="flex flex-col gap-4 md:flex-row-reverse">
      <div class="md:flex md:flex-col md:justify-center">
        <h4 class="text-base font-medium text-blue-900">{{ name() }}</h4>
        @if (dimensions() && tip()) {
          <ul class="mt-2 flex flex-col gap-1 md:flex-row md:gap-3">
            @if (dimensions()) {
              <li class="text-gray-750 flex items-center gap-1 text-xs font-normal">
                <csl-icon name="sizes" class="block size-4 text-[--container-volume-card-selected-icon-bg-color]" />
                {{ dimensions() }}
              </li>
            }
            @if (tip()) {
              <li class="text-gray-750 flex items-center gap-1 text-xs font-normal">
                <csl-icon name="pickup" class="block size-4 text-[--container-volume-card-selected-icon-bg-color]" />
                {{ tip() }}
              </li>
            }
          </ul>
        }
      </div>
      <img [ngSrc]="containerImage" alt="container image" height="58" width="104" />
    </div>
  </div>
} @else {
  <div
    [cslTooltip]="description()"
    [tooltipFocusable]="false"
    class="-md:gap-2 relative flex w-full cursor-pointer items-center p-4 md:flex-col md:px-5 md:pb-5 md:pt-2"
    tooltipClass="hidden md:block"
  >
    <div
      [ngClass]="{
        'border-[--container-volume-card-selected-icon-bg-color] bg-[--container-volume-card-selected-icon-bg-color]':
          selected(),
        'border-gray-700': !selected(),
      }"
      class="flex size-6 shrink-0 items-center justify-center rounded-[50%] border md:absolute md:right-[12px] md:top-[12px]"
    >
      @if (selected()) {
        <csl-icon name="checkmark" class="size-6 bg-[--container-volume-card-selected-icon-color]" />
      }
    </div>
    <img [ngSrc]="containerImage" alt="container image" class="mb-1 size-16" height="80" width="90" />
    <div class="flex flex-col md:items-center">
      <div class="min-w-[110px] text-base font-medium text-blue-900 md:text-center">
        {{ size() }} {{ unitOfMeasure() | pluralizeUnit | titlecase }}
      </div>
      @if (description()) {
        <div class="text-gray-750 mt-1 text-xs font-normal md:hidden">
          @if (isSimpleType) {
            {{ description() }}
          } @else {
            <ng-template [ngTemplateOutlet]="$any(description())"></ng-template>
          }
        </div>
      }
    </div>
  </div>
}
